
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bubble': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path d="M7.57895 0C3.39242 0 0 3.39242 0 7.57895C0 11.7655 3.39242 15.1579 7.57895 15.1579C7.72872 15.1579 8.02477 15.1579 8.02477 15.1579V17.8328C8.02477 17.8328 15.1579 14.2279 15.1579 7.57895C15.1579 3.39242 11.7655 0 7.57895 0Z" fill="#414162"/>'
  }
})
